"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const first_1 = __importDefault(require("lodash/first"));
const last_1 = __importDefault(require("lodash/last"));
const round_1 = __importDefault(require("lodash/round"));
const Location_1 = require("../../models/Location");
const Trip_1 = require("../../models/Trip");
const expect_1 = __importDefault(require("../../util/expect"));
const unwrap_1 = __importDefault(require("../../util/unwrap"));
const DirectionsInput_1 = require("./DirectionsInput");
const GoogleMapsController_1 = __importDefault(require("./GoogleMapsController"));
const DirectionsController = {
    read: async (origin, destination, options) => {
        return GoogleMapsController_1.default.request('directions', [
            ['origin', (0, DirectionsInput_1.directionsInputString)(origin)],
            ['destination', (0, DirectionsInput_1.directionsInputString)(destination)],
            ...(0, unwrap_1.default)(options, it => [
                (0, unwrap_1.default)(it.arrivalTimestampS, timestamp => ['arrival_time', String((0, round_1.default)(timestamp))]),
                (0, unwrap_1.default)(it.departureTimestampS, timestamp => ['departure_time', String((0, round_1.default)(timestamp))]),
                ...(0, unwrap_1.default)(it.waypoints, waypoints => waypoints.map(waypoint => ['waypoints[]', (0, DirectionsInput_1.directionsInputString)(waypoint)]), () => []),
            ], () => []).filter(Boolean),
        ], options);
    },
    readForInputs(inputs, options) {
        if (inputs.length < 2) {
            throw new Error('Directions need at least two directions inputs');
        }
        const origin = (0, expect_1.default)((0, first_1.default)(inputs));
        const destination = (0, expect_1.default)((0, last_1.default)(inputs));
        const waypoints = inputs.length > 2 ? inputs.slice(1, -1) : undefined;
        return this.read(origin, destination, Object.assign({ waypoints }, options));
    },
    readForTrip(trip, driverCoordinates, options) {
        const inputs = (0, Trip_1.tripLocationsWithDefault)(trip).map(Location_1.locationDirectionsInput);
        if (driverCoordinates) {
            inputs.splice(0, 0, driverCoordinates);
        }
        return this.readForInputs(inputs, options);
    },
    readForTripLocations(locations, options) {
        return this.readForInputs(locations.map(Location_1.locationDirectionsInput), options);
    },
};
exports.default = DirectionsController;
